<template>
  <el-dialog
    :visible.sync="detail.dialog"
    top="5vh"
    custom-class="dialogHistoryEdit"
    style="font-family: 'Prompt', sans-serif"
    append-to-body
    width="70%">
    <template slot="title">
        <h1 style="margin:unset;text-align:left;">ประวัติการแก้ไข</h1>
    </template>
    <el-row>
        <el-col :span="24" v-if="rawHistory.length > 0 || closeTagData.length > 0">
            <el-row>
                    <el-col :span="24" v-if="closeTagData.length > 0">
                        <div v-for="(tag,index) in closeTagData" :key="index">
                        <span><b>{{$dayjs.unix(tag.timestamp).format('YYYY-MM-DD HH:mm:ss')}}</b></span>
                        <span>&nbsp;แก้ไขโดย : <b>{{detail.userEmail}}</b></span>
                        <span>&nbsp;สาเหตุ : <b>{{getOperationTag(tag.approveStatus)}}</b></span>
                        </div>
                     </el-col>
            </el-row>
            <el-collapse v-model="activeUserInfo" accordion>
                <el-collapse-item v-for="(item,index) in rawHistory" :key="index" :name="index">
                    <template slot="title">
                        <span><b>{{$dayjs.unix(item.timestamp).format('YYYY-MM-DD HH:mm:ss')}}</b></span>
                        <span>&nbsp;แก้ไขโดย : <b>{{item.editorEmail}}</b></span>
                        <span>&nbsp;สาเหตุ : <b>{{item.editorValue}}</b></span>
                    </template>
                    <!-- <el-row v-if="!item.diffUserCheck && !item.diffCourierCheck">
                        <span><b>ไม่มีการแก้ไข</b></span>
                    </el-row> -->
                    <el-row v-if="item.diffOnlineCheck">
                        <el-col :span="24">
                            <div v-for="(diffOnline,indexUser) in item.diffOnline" :key="indexUser">
                                <!-- <span>- ตีกลับข้อมูล <b>{{diffOnline}}</span> -->
                              <span v-if="rejectPathName(diffOnline.path[0])">ตีกลับข้อมูล <b>{{rejectPathName(diffOnline.path[0])}}</b> จาก <b>{{getOnlineText(diffOnline.path[0],diffOnline.lhs)}}</b></span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="item.diffUserCheck">
                        <el-col :span="24">
                            <div v-for="(diffUser,indexUser) in item.diffUser" :key="indexUser">
                                <template v-if="diffUser.path[0] === 'deliveryCostType'">
                                    <span>- แก้1 <b>{{pathName(diffUser.path[0])}}</b> จาก <b>{{getPriceType(diffUser.lhs)}}</b> เป็น <b>{{getPriceType(diffUser.rhs)}}</b> </span>
                                </template>
                                <template v-else>
                                    <span>- แก้ <b>{{pathName(diffUser.path[0])}}</b> จาก <b>{{diffUser.lhs}}</b> เป็น <b>{{diffUser.rhs}}</b> </span>
                                </template>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="item.diffCourierCheck">
                        <el-col :span="12">
                            <el-table
                                :data="item.diffCourier.lhs"
                                border
                                :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                style="width: 100%">
                                <el-table-column
                                fixed
                                prop="name"
                                label="Courier Name"
                                width="140">
                                </el-table-column>
                                <el-table-column label="shipper Code" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.shipperCode : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="ผู้ใช้งาน" min-width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.username : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="รหัสผ่าน" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.password : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="วัน" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{scope.row.day}}
                                    </div>
                                </el-table-column>
                            </el-table>
                        </el-col>
                        <el-col :span="12">
                            <el-table
                                :data="item.diffCourier.rhs"
                                border
                                :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                style="width: 100%">
                                <el-table-column
                                fixed
                                prop="name"
                                label="Courier Name"
                                width="140">
                                </el-table-column>
                                <el-table-column label="shipper Code" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.shipperCode : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="ผู้ใช้งาน" min-width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.username : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="รหัสผ่าน" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.apiData.status ? scope.row.apiData.password : '-' }}
                                    </div>
                                </el-table-column>
                                <el-table-column label="วัน" width="120">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{scope.row.day}}
                                    </div>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-col>
        <el-col :span="24" v-else class="text-md-center">
            <span style="font-size:24px;">ไม่มีประวัติการแก้ไข</span>
        </el-col>
    </el-row>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="detail.dialog = false">ยกเลิก</el-button>
    </span>
  </el-dialog>
</template>
<script>
import fgApi from '@/services/fillgoods'
import diff from 'deep-diff'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
export default {
    name: 'dialogHistoryEdit',
    props: {
        detail: {
            type: Object
        }
    },
    mixins: [onlineOperationUtility],
    data () {
        return {
            rawHistory: [],
            closeTagData: [],
            activeUserInfo: 0
        }
    },
    watch: {
        'detail.dialog' (val) {
            if (val) {
                this.fetchHistory()
                this.fetchCloseTag()
            } else {
                this.rawHistory = []
                this.activeUserInfo = 0
            }
        }
    },
    methods: {
        async fetchHistory () {
            let loading = this.$loading({
                target: '.dialogHistoryEdit'
            })
            let param = {
                user_id: this.detail.userId
            }
            try {
                let res = await fgApi.log.getLogEditUser(param)
                if (res.success) {
                    this.rawHistory = res.data
                    await this.historyConvert(this.rawHistory)
                }
                // console.log(res)
            } catch (error) {
                console.log(error)
            }
            loading.close()
        },
        async fetchCloseTag () {
            let loading = this.$loading({
                target: '.dialogHistoryEdit'
            })
            let param = {
                user_id: this.detail.userId
            }
            try {
                let res = await fgApi.log.getOperationCancelTagTimeStamp(param)

                if (res.success) {
                    this.closeTagData = res.data
                }
            } catch (error) {
                console.log(error)
            }
            loading.close()
        },
        historyConvert (data) {
            // console.log(data)
            const convertAutoCourier = (courier) => {
                let courierList = []
                if (Object.entries(courier).length > 0) {
                    courier.autoCourier.map((e) => {
                        courier.courierAccounts.filter(el => {
                            if (el.courierAccountId === e.courierAccountId) {
                                courierList.push({ ...el, day: e.day })
                            }
                        })
                    })
                }
                return courierList
            }
            data.forEach((e, index) => {
                // Log UserInfo
                let differencesUserInfo = diff(e.payload.lhs.detail, e.payload.rhs.detail)
                this.rawHistory[index] = { ...this.rawHistory[index], diffUser: differencesUserInfo }
                if (differencesUserInfo) {
                    this.rawHistory[index] = { ...this.rawHistory[index], diffUserCheck: true }
                } else {
                    this.rawHistory[index] = { ...this.rawHistory[index], diffUserCheck: false }
                }

                // Log online operation rejection
                let differencesOnline = diff(e.payload.lhs.online, e.payload.rhs.online)
                this.rawHistory[index] = { ...this.rawHistory[index], diffOnline: differencesOnline }
                if (differencesOnline) {
                    this.rawHistory[index] = { ...this.rawHistory[index], diffOnlineCheck: true }
                } else {
                    this.rawHistory[index] = { ...this.rawHistory[index], diffOnlineCheck: false }
                }

                // Log Courier
                let differencesCourier = diff(convertAutoCourier(e.payload.lhs.courier), convertAutoCourier(e.payload.rhs.courier))
                if (differencesCourier) {
                    this.rawHistory[index] = { ...this.rawHistory[index],
                        diffCourier: {
                            lhs: convertAutoCourier(e.payload.lhs.courier),
                            rhs: convertAutoCourier(e.payload.rhs.courier)
                        } }
                    this.rawHistory[index] = { ...this.rawHistory[index], diffCourierCheck: true }
                } else {
                    this.rawHistory[index] = { ...this.rawHistory[index], diffCourierCheck: false }
                }
            })
            console.log(this.rawHistory)
        },
        pathName (path) {
            let pathName = {
                email: 'อีเมล',
                firstName: 'ชื่อ',
                lastName: 'นามสกุล',
                userCode: 'userCode',
                address: 'ที่อยู่',
                subDistrict: 'ตำบล',
                district: 'อำเภอ',
                province: 'จังหวัด',
                zipcode: 'รหัสไปรษณีย์',
                phoneNumber: 'เบอร์โทรศัพท์',
                isActivate: 'isActivate',
                userStatus: 'userStatus',
                saleCode: 'saleCode',
                saleCodeSec: 'Secondary Sale',
                deliveryCostType: 'Price Type',
                customerRetention: 'Customer Retention'
            }
            if (pathName.hasOwnProperty(path)) {
                return pathName[path]
            } else {
                return path
            }
        },
        rejectPathName (path) {
            let pathName = {
                bankAccountType: 'ประเภทบัญชี',
                legalName: 'ชื่อนิติบุคคล',
                firstName: 'ชื่อ',
                lastName: 'นามสกุล',
                taxId: 'เลขประจำตัวผู้เสียภาษีนิติบุคคล',
                bankAccountEmail: 'อีเมล์สำหรับบัญชี',
                bankAccountAddress: 'ที่อยู่ตามใบกำกับภาษี',
                bankAccountProvince: 'จังหวัด',
                bankAccountDistrict: 'อำเภอ',
                bankAccountSubDistrict: 'ตำบล',
                bankAccountZipcode: 'รหัสไปรษณีย์',
                bankName: 'บัญชีธนาคาร',
                bankAccountNumber: 'หมายเลขบัญชีธนาคาร',
                bankAccountName: 'ชื่อบัญชี',
                idCardImage: 'รูปบัตรประชาชน',
                bookBankImage: 'รูปหน้า Book Bank',
                companyImage: 'หนังสือรับรองนิติบุคคล'
            }
            if (pathName.hasOwnProperty(path)) {
                return pathName[path]
            }
        },
        getOnlineText (path, val) {
            // console.log('path', path)
            if (path === 'bankAccountType') {
                return this.getBankAccountType(val)
            } else if (path === 'bankName') {
                return this.getBank(val)
            } else {
                return val
            }
        }
    }
}
</script>
<style lang="scss">
.dialogHistoryEdit {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}

</style>
